import { version as e } from "../../version.js";
import { getConsoleStyle as s } from "./styledLogs.js";
const t = (o) => console.log("%c%s", s(), o), l = () => {
  const o = `RIO UIKIT Version ${e}
https://uikit.developers.rio.cloud`;
  t(o);
};
export {
  l as usedUikitVersion
};
//# sourceMappingURL=usedUikitVersion.js.map
